import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { GoogleLogin } from '@react-oauth/google';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';

export default function Login() {
  const { login, API, loginWithToken } = useAuth();
  const navigate                       = useNavigate();
  const [email, setEmail]              = useState('');
  const [password, setPassword]        = useState('');
  const [error, setError]              = useState('');
  const [loading, setLoading]          = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const result = await login(email, password);
      if (result.success) {
        navigate('/dashboard');
      } else {
        setError(result.message || 'Invalid email or password');
      }
    } catch (err) {
      setError('Connection error. Please try again.');
    }
    setLoading(false);
  };

  const handleGoogleSuccess = async (credentialResponse) => {
    setError('');
    setLoading(true);
    try {
      const res = await axios.post(API + '/users/google-login', {
        googleToken: credentialResponse.credential,
      });

      if (res.data.success) {
        loginWithToken(res.data);
        navigate('/dashboard');
      } else {
        setError(res.data.message ||
          'Your account is pending admin approval.');
      }
    } catch (e) {
      setError('Google login failed. Please try again.');
    }
    setLoading(false);
  };

  return (
    <div style={styles.page}>
      <div style={styles.grid} />

      <div style={styles.card}>

        {/* Logo */}
        <div style={styles.logoWrap}>
          <div style={styles.logoIcon}>FX</div>
          <div>
            <div style={styles.logoTitle}>FX CAPITAL INDIA</div>
            <div style={styles.logoSub}>Rate Management Portal</div>
          </div>
        </div>

        <div style={styles.divider} />

        {/* Google Login */}
        <div style={styles.googleWrap}>
          <GoogleLogin
            onSuccess={handleGoogleSuccess}
            onError={() => setError('Google login failed')}
            text="signin_with"
            shape="rectangular"
            theme="filled_black"
            width="100%"
          />
        </div>

        <div style={styles.orRow}>
          <div style={styles.orLine} />
          <span style={styles.orText}>OR</span>
          <div style={styles.orLine} />
        </div>

        {/* Form */}
        <form onSubmit={handleLogin} style={styles.form}>

          <div style={styles.fieldWrap}>
            <label style={styles.label}>EMAIL ADDRESS</label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
              style={styles.input}
              onFocus={e => e.target.style.borderColor = '#C9A84C'}
              onBlur={e  => e.target.style.borderColor = '#1E3050'}
            />
          </div>

          <div style={styles.fieldWrap}>
            <label style={styles.label}>PASSWORD</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="Enter your password"
              required
              style={styles.input}
              onFocus={e => e.target.style.borderColor = '#C9A84C'}
              onBlur={e  => e.target.style.borderColor = '#1E3050'}
            />
          </div>

          {error && (
            <div style={styles.error}>{error}</div>
          )}

          <button
            type="submit"
            disabled={loading}
            style={{
              ...styles.btn,
              opacity: loading ? 0.7 : 1,
              cursor:  loading ? 'not-allowed' : 'pointer',
            }}>
            {loading ? 'SIGNING IN...' : 'SIGN IN'}
          </button>

        </form>

        {/* Register Link */}
        <div style={styles.registerRow}>
          New to FX Capital India?{' '}
          <span
            onClick={() => navigate('/register')}
            style={styles.registerLink}>
            Create Account
          </span>
        </div>

        <div style={styles.footer}>
          Secure access — FX Capital India
        </div>

      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight:      '100vh',
    background:     '#080F1A',
    display:        'flex',
    alignItems:     'center',
    justifyContent: 'center',
    position:       'relative',
    overflow:       'hidden',
  },
  grid: {
    position:   'absolute',
    inset:      0,
    background: `
      linear-gradient(rgba(37,99,168,0.04) 1px, transparent 1px),
      linear-gradient(90deg, rgba(37,99,168,0.04) 1px, transparent 1px)
    `,
    backgroundSize: '40px 40px',
    pointerEvents:  'none',
  },
  card: {
    background:   '#0D1B2A',
    border:       '1px solid #1E3050',
    borderRadius: '12px',
    padding:      '40px 44px',
    width:        '100%',
    maxWidth:     '420px',
    position:     'relative',
    boxShadow:    '0 24px 64px rgba(0,0,0,0.5)',
  },
  logoWrap: {
    display:      'flex',
    alignItems:   'center',
    gap:          '14px',
    marginBottom: '24px',
  },
  logoIcon: {
    width:          '48px',
    height:         '48px',
    background:     'linear-gradient(135deg, #C9A84C, #8B6914)',
    borderRadius:   '10px',
    display:        'flex',
    alignItems:     'center',
    justifyContent: 'center',
    fontFamily:     'Rajdhani, sans-serif',
    fontSize:       '20px',
    fontWeight:     700,
    color:          '#080F1A',
    letterSpacing:  '0.05em',
  },
  logoTitle: {
    fontFamily:    'Rajdhani, sans-serif',
    fontSize:      '18px',
    fontWeight:    700,
    color:         '#C9A84C',
    letterSpacing: '0.1em',
  },
  logoSub: {
    fontFamily: 'Inter, sans-serif',
    fontSize:   '11px',
    color:      '#8896A8',
    marginTop:  '2px',
  },
  divider: {
    height:       '1px',
    background:   'linear-gradient(90deg, transparent, #1E3050, transparent)',
    marginBottom: '24px',
  },
  googleWrap: {
    display:      'flex',
    justifyContent: 'center',
    marginBottom: '20px',
  },
  orRow: {
    display:      'flex',
    alignItems:   'center',
    gap:          '12px',
    marginBottom: '20px',
  },
  orLine: {
    flex:       1,
    height:     '1px',
    background: '#1E3050',
  },
  orText: {
    fontFamily: 'Inter, sans-serif',
    fontSize:   '12px',
    color:      '#4A5568',
  },
  form: {
    display:       'flex',
    flexDirection: 'column',
    gap:           '20px',
  },
  fieldWrap: {
    display:       'flex',
    flexDirection: 'column',
    gap:           '6px',
  },
  label: {
    fontFamily:    'Rajdhani, sans-serif',
    fontSize:      '11px',
    fontWeight:    600,
    color:         '#8896A8',
    letterSpacing: '0.12em',
  },
  input: {
    background:   '#111E2E',
    border:       '1px solid #1E3050',
    borderRadius: '6px',
    padding:      '10px 14px',
    color:        '#E8EDF5',
    fontSize:     '14px',
    fontFamily:   'Inter, sans-serif',
    outline:      'none',
    transition:   'border-color 0.2s',
    width:        '100%',
  },
  error: {
    background:   'rgba(239,68,68,0.08)',
    border:       '1px solid rgba(239,68,68,0.3)',
    borderRadius: '6px',
    padding:      '10px 14px',
    color:        '#EF4444',
    fontSize:     '13px',
    fontFamily:   'Inter, sans-serif',
  },
  btn: {
    background:    'linear-gradient(135deg, #C9A84C, #8B6914)',
    border:        'none',
    borderRadius:  '6px',
    padding:       '12px',
    color:         '#080F1A',
    fontFamily:    'Rajdhani, sans-serif',
    fontSize:      '15px',
    fontWeight:    700,
    letterSpacing: '0.1em',
    transition:    'opacity 0.2s',
    width:         '100%',
    marginTop:     '4px',
  },
  registerRow: {
    textAlign:  'center',
    fontSize:   '13px',
    color:      '#8896A8',
    fontFamily: 'Inter, sans-serif',
    marginTop:  '20px',
  },
  registerLink: {
    color:  '#C9A84C',
    cursor: 'pointer',
  },
  footer: {
    marginTop:  '16px',
    textAlign:  'center',
    fontSize:   '11px',
    color:      '#4A5568',
    fontFamily: 'Inter, sans-serif',
  },
};